const navbar = document.querySelector('.navbar-desktop.sticky');
window.onscroll = () => {
    if (window.scrollY > 100) {
        navbar.classList.add('nav-scrolled');
    } else {
        navbar.classList.remove('nav-scrolled');
    }
};